"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectionSymbols = void 0;
/*
 * © 2024 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
exports.selectionSymbols = {
    none: " ",
    all: "✔\uFE0E",
    inner: "◾\uFE0E",
    outer: "▣\uFE0E",
};
//# sourceMappingURL=selectionSymbols.js.map